import { useState, useCallback } from 'react';
import { useGateway } from './useGateway';
import { CreateOrderRequest, CreateOrderResponse, OrderMetadata } from '../types/order';

/**
 * Hook for order operations using the service-based architecture
 */
export const useOrdersService = () => {
  const { gateway, handleRequest, isLoading, error } = useGateway();
  const [order, setOrder] = useState<OrderMetadata | null>(null);

  /**
   * Create a new order
   */
  const createOrder = useCallback(async (orderData: CreateOrderRequest): Promise<CreateOrderResponse | null> => {
    return await handleRequest(() => gateway.orders.createOrder(orderData), { rethrow: true });
  }, [gateway.orders, handleRequest]);

  /**
   * Get order details by ID
   */
  const getOrder = useCallback(async (orderId: string): Promise<OrderMetadata | null> => {
    const result = await handleRequest(() => gateway.orders.getOrder(orderId));
    if (result) {
      setOrder(result);
    }
    return result;
  }, [gateway.orders, handleRequest]);

  return {
    order,
    isLoading,
    error,
    createOrder,
    getOrder,
  };
};
